import React, { useEffect, useState } from "react";
import { Grid, Typography, CardContent } from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";
import { Button, Card } from "react-bootstrap";

const RetailerDashboard = () => {
  const userData = JSON.parse(sessionStorage.getItem("key"));
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1100) {
        setSidebarVisible(false);
      } else {
        setSidebarVisible(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div style={{ backgroundColor: "#f5f5f9", minHeight: "100vh" }}>
      <Grid container>
        {isSidebarVisible && (
          <Grid item xs={12} md={3}>
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} md={isSidebarVisible ? 9 : 12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
              {/* </Grid> */}
              <Grid item xs={11}>
                <Card style={{ marginTop: "24px", backgroundColor: "#ffffff" }}>
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} sm={7}>
                        <Typography variant="h5" color="primary" gutterBottom>
                          Hello {userData.data.ownername}! 🎉
                        </Typography>
                        <Typography gutterBottom>
                          Your business name is{" "}
                          <span className="fw-bold">
                            {userData.data.businessname}
                          </span>{" "}
                          . Check your new badge in your profile.
                        </Typography>
                        <Button
                          component={Link}
                          to="javascript:;"
                          variant="contained"
                          color="blue"
                          size="small"
                        >
                          View Badges
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={5} textAlign="center">
                        <img
                          src="../assets/img/illustrations/man-with-laptop-light.png"
                          height="140"
                          alt="View Badge User"
                          data-app-dark-img="illustrations/man-with-laptop-dark.png"
                          data-app-light-img="illustrations/man-with-laptop-light.png"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default RetailerDashboard;
